/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdresseCarteResource } from '../models/AdresseCarteResource';
import type { ClientRequest } from '../models/ClientRequest';
import type { ClientResource } from '../models/ClientResource';
import type { ClientStoreRequest } from '../models/ClientStoreRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ClientService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Recherche des clients autour d'un point
     * Retourne les adresses de chantier autour d'un point geographique, avec leur client (version allegee, sans projets). Un marqueur par position et par client : `NB_CHANTIERS` compte les chantiers regroupes. `RAYON` en km, 5 au maximum. `RDV_DU` / `RDV_AU` (AAAA-MM-JJ, ensemble) ne gardent que les projets ayant un rendez-vous non supprime dans la periode ; `AVEC_RAF` ne garde que ceux ayant du reste a faire.
     * @param latitude
     * @param longitude
     * @param rayon Regle ecrite en clair : Scramble n'analyse pas une concatenation,
     * et abandonne alors TOUTE la documentation des parametres de la route
     * @param rdvDu self::ARROUND_RAYON_MAX_KM
     * @param rdvAu
     * @param avecRaf
     * @returns AdresseCarteResource Array of `AdresseCarteResource`
     * @throws ApiError
     */
    public clientArroundClient(
        latitude: number,
        longitude: number,
        rayon: number,
        rdvDu?: string | null,
        rdvAu?: string | null,
        avecRaf?: boolean | null,
    ): CancelablePromise<Array<AdresseCarteResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/arround/clients',
            query: {
                'LATITUDE': latitude,
                'LONGITUDE': longitude,
                'RAYON': rayon,
                'RDV_DU': rdvDu,
                'RDV_AU': rdvAu,
                'AVEC_RAF': avecRaf,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Fiche d'un client depuis la carte
     * Le client, son adresse et ses projets (avec leurs devis), pour le popup d'un marqueur. 403 si l'utilisateur n'a pas le droit d'ouvrir cette fiche (regle de Lola : droit `CLIENT_TOUS`, agence, ou client / projet dont il est responsable). 404 s'il n'existe pas.
     * @param id
     * @returns ClientResource `ClientResource`
     * @throws ApiError
     */
    public clientArroundClientShow(
        id: string,
    ): CancelablePromise<ClientResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/arround/clients/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
            },
        });
    }
    /**
     * Rechercher des clients
     * Par `NOM`, `PRENOM`, `VILLE` et/ou `PORTABLE` (format `06 12 34 56 78`, espaces optionnels). Renvoie au plus 15 clients, avec leur adresse et leurs projets.
     * @param nom
     * @param prenom
     * @param ville
     * @param portable
     * @returns ClientResource Array of `ClientResource`
     * @throws ApiError
     */
    public clientIndex(
        nom?: string | null,
        prenom?: string | null,
        ville?: string | null,
        portable?: string,
    ): CancelablePromise<Array<ClientResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients',
            query: {
                'NOM': nom,
                'PRENOM': prenom,
                'VILLE': ville,
                'PORTABLE': portable,
            },
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Creer un client et son projet
     * Cree le client, son adresse (`ADRESSE`) et un premier projet (`PROJET`). **Detection de doublon** : si un client existe deja avec le meme `MAIL` ou le meme `PORTABLE`, le projet est rattache a ce client existant au lieu d'en creer un second ; `?skip_duplicate_check=1` force la creation. Agence et responsable : ceux du `PROJET` s'ils sont fournis, sinon ceux du personnel connecte. 201 avec le client (existant ou cree).
     * @param skipDuplicateCheck
     * @param setRelanceIntermediaire
     * @param requestBody
     * @returns ClientResource `ClientResource`
     * @throws ApiError
     */
    public clientsStore(
        skipDuplicateCheck: string = 'false',
        setRelanceIntermediaire: string = 'false',
        requestBody?: (ClientStoreRequest & Record<string, any>),
    ): CancelablePromise<ClientResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients',
            query: {
                'skip_duplicate_check': skipDuplicateCheck,
                'set_relance_intermediaire': setRelanceIntermediaire,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un client
     * Avec son adresse et ses projets. 404 s'il n'existe pas.
     * @param id
     * @returns ClientResource `ClientResource`
     * @throws ApiError
     */
    public clientsShow(
        id: string,
    ): CancelablePromise<ClientResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier un client
     * Mise a jour partielle. 404 s'il n'existe pas.
     * @param id
     * @param requestBody
     * @returns ClientResource `ClientResource`
     * @throws ApiError
     */
    public clientsUpdate(
        id: string,
        requestBody?: ClientRequest,
    ): CancelablePromise<ClientResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un client
     * Suppression definitive. Renvoie le client supprime ; 404 s'il n'existe pas.
     * @param id
     * @returns ClientResource `ClientResource`
     * @throws ApiError
     */
    public clientsDestroy(
        id: string,
    ): CancelablePromise<ClientResource> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Webhook : creer un client depuis un formulaire
     * Recoit dans `json` (chaine JSON) un client et son projet, verifie la structure et cree le client. 400 avec `{ error }` si la structure est invalide.
     * @returns string
     * @throws ApiError
     */
    public clientAiImport(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/webhook/contact/create',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
